import './bootstrap'
import 'flowbite'


import { initLocale as initCookieConsentLocale } from "@pcsoft/cookieconsent/js/lang/locales";
import { initIframeManager as initCookieConsentIframeManager } from "@pcsoft/cookieconsent/js/components/IframeManager";
import { initCookieConsent } from "@pcsoft/cookieconsent/js/components/CookieConsent";
import InputCodePub, { initInputCodePub } from "./components/inputs/input-codepub";
import InputState, { initInputState } from "./components/inputs/input-state";
import { initTooltipMouse } from "./components/tooltip-mouse/tooltip-mouse";
import Slider, { initSlider} from "./components/slider/slider";
import { initModalPromoCode } from './../../vendor/pcsoft/promo-code/resources/js/modal-promo-code';
import { initFollowParam } from './core/FollowParams.js'

import Events from './dom/events'

/**
 * Déclaration et initialisation des composants lors de l'élément load javascript
 * @type {Events}
 */
const events = new Events('load', [
    () => initModalPromoCode({
        lang: 'fr',
        force_display: false,
        subscription_url: '//pcsoft.fr/neo',
        callback: function () {
            initFollowParam()
        }
    }),
    initCookieConsentLocale,
    initCookieConsentIframeManager,
    initCookieConsent,
    initInputCodePub,
    initInputState,
    initTooltipMouse,
    initSlider
])

events.init()


import lazySizes from 'lazysizes';
lazySizes.cfg.lazyClass = 'lazy';
lazySizes.cfg.srcAttr = 'data-original';
// lazySizes.cfg.preloadAfterLoad = true;

import './../../vendor/pcsoft/download/resources/js/app.js'
// PACKAGE DE TEST EN DEV import './../../packages/pcsoft-download/resources/js/app.js'

import './components/PerfectScrollBar'

import { WTCitySelector } from './components/WTCitySelector'
window.customElements.define('wt-city-selector', WTCitySelector, { extends : 'div' })
